<template>
  <div class="sv sv053">
    <div class="container">
      <BreadcrumbGroup :items="breadcrumbItems" />

      <ContentsHeader class="-blue" src="sv053/main.jpg">
        <p class="heading1">教えて！みんなのローン活用術</p>
        <h1 class="heading2">“ちょっとだけ”がすごく助かる<br />生活の工夫</h1>
      </ContentsHeader>
    </div>

    <div class="container">
      <ContentsIntro
        class="-blue _pt-sm-60"
        icon-left="sv053/avatar-a.gif"
        name-left="Aさん"
        icon-right="sv053/avatar-b.gif"
        name-right="Bさん"
        txt-relation="友人の2人"
      >
        AさんとBさんは学生時代からの友人で、いまでもお休みを合わせて一緒に旅行にいく間柄です。<br />
        この前の旅行話に思い出を咲かせようとしたところ、Bさんはなんだか浮かない顔をしていて･･･。
      </ContentsIntro>
    </div>

    <hr class="-pcnone _mb-sm-60" />

    <div class="container">
      <HeadingTwo>連休でついついかさんだ出費…どうにかしたい。</HeadingTwo>

      <TalkGroup>
        <TalkBox src="sv053/avatar-a.gif"
          >この前の大型連休の旅行は楽しかったね。それに、同級生たちの結婚式もあってなかなか忙しかったね</TalkBox
        >
        <TalkBox src="sv053/avatar-b.gif">そうだね･･･</TalkBox>
        <TalkBox src="sv053/avatar-a.gif"
          >どうした、なんか元気がないよ？
        </TalkBox>
        <TalkBox src="sv053/avatar-b.gif"
          >楽しかったのは楽しかったけど、おかげで今月ピンチだよ</TalkBox
        >
        <TalkBox src="sv053/avatar-a.gif">確かに出費は多かったからね</TalkBox>
        <TalkBox src="sv053/avatar-b.gif"
          >1人暮らしをしていると、食事とか日用品にどうしてもお金がかかってしまうし</TalkBox
        >
        <TalkBox src="sv053/avatar-a.gif"
          >そうだよね。食べない、買わない訳にはいかないからね</TalkBox
        >
        <TalkBox src="sv053/avatar-b.gif"
          >次の給料日まで結構きついよ、ランチとか節約して乗り越えなきゃ･･･そうだ･･･トイレットペーパーもそろそろなくなるかも。あ～生活が不安だよ</TalkBox
        >
      </TalkGroup>

      <HeadingTwo class="_mt-md-110 _mt-sm-60"
        >ちょっとだけ足りない生活費を手助けしてもらう</HeadingTwo
      >

      <TalkGroup src="sv053/img01.jpg">
        <TalkBox src="sv053/avatar-b.gif"
          >Aは大丈夫なの、あまり収入は変わらないはずだけど</TalkBox
        >
        <TalkBox src="sv053/avatar-a.gif"
          >楽ではないよ。食費とかを節約するのはしょうがないと思うけど、我慢をしなければならないのは、仕事とか生活に影響が出そうで嫌だし、もちろんトイレットペーパーがなくなるのもつらいから、ちょっとだけ生活の工夫をしているんだ</TalkBox
        >
        <TalkBox src="sv053/avatar-b.gif">生活の工夫？教えて！</TalkBox>
      </TalkGroup>

      <TalkGroup class="_mb-60">
        <TalkBox src="sv053/avatar-a.gif"
          >実は、こういうときはキャッシングやローンでお金を借りているんだ</TalkBox
        >
        <TalkBox src="sv053/avatar-b.gif"
          >そうなんだ！でもそれ大丈夫なの？</TalkBox
        >
        <TalkBox src="sv053/avatar-a.gif"
          >言われると思ったよ。でも全然大丈夫だよ。借りる前に色々と調べたけど、テレビに出てくるような怖いことはまったくないし、法律で借りる人を守ってくれてるみたいだし</TalkBox
        >
        <TalkBox src="sv053/avatar-b.gif">よく調べたね</TalkBox>
        <TalkBox src="sv053/avatar-a.gif"
          >だって初めは不安じゃん。でも今は、出費の多い月とかは生活費の足しにちょっとだけ借りて、お給料が入ったら返済をしているんだ。すぐに返済をすれば利息もそこまでかからないし</TalkBox
        >
        <TalkBox src="sv053/avatar-b.gif"
          >そうなんだね。でもなかなか踏み切れないな</TalkBox
        >
        <TalkBox src="sv053/avatar-a.gif"
          >そうだよね。確かに便利だけど、借りすぎたり、使いすぎたりするのは気をつけないといけないと思ってるんだ。あくまでも“ちょっとだけ”生活費の足しにする意識を忘れないようにしているよ</TalkBox
        >
        <TalkBox src="sv053/avatar-b.gif"
          >俺も“ちょっとだけ”考えてみようかな</TalkBox
        >
        <TalkBox src="sv053/avatar-a.gif"
          >トイレットペーパーぐらいなら俺が貸してあげるからね</TalkBox
        >
      </TalkGroup>

      <ContentsCard class="-blue _mb-sm-30 _mb-md-30">
        <div class="card-header">
          <IconBox src="light-blue" class="-md _mb-sm-10"></IconBox>
          <h3 class="heading">
            au PAY スマートローンなら<br class="-pcnone" />こんなに便利！
          </h3>
        </div>
        <div class="card-body">
          <p class="txt01">
            ご利用限度額は、１万円~100万円（※）まで。カードレスでご利用はすべてスマートフォンで完結するのでとっても便利！
          </p>
          <ListGroup class="-note">
            <ListItem class="-note -textcenter _mb-25"
              >実際のご契約条件は、お申し込み後の審査に基づきご提示させていただきます。
            </ListItem>
          </ListGroup>

          <div class="card-groups">
            <div class="card-box">
              <div class="card-image -width90">
                <img
                  src="@/assets/images/sv/sv053/img02.jpg"
                  class="img-fluid"
                  alt=""
                />
              </div>
              <div class="card-body">
                お借り入れは1万円から！一時的にお金が足りないときに頼れる味方です。
              </div>
            </div>
            <div class="card-box">
              <div class="card-image -width80">
                <img
                  src="@/assets/images/sv/sv053/img03.jpg"
                  class="img-fluid"
                  alt=""
                />
              </div>
              <div class="card-body">
                スマートフォンがあれば、新規お申し込みもお借り入れもかんたんWEB完結！
              </div>
            </div>
            <div class="card-box">
              <div class="card-image -width80">
                <img
                  src="@/assets/images/sv/sv001/img07.gif"
                  class="img-fluid"
                  alt=""
                />
              </div>
              <div class="card-body">
                au PAY 残高にそのままチャージができます。チャージした残高は、au
                PAY プリペイドカードやau
                PAYで全国のコンビニ・スーパーやMastercard®加盟店、au
                PAY加盟店などいろいろな場所で使え、Pontaポイントもたまります。
              </div>
            </div>
          </div>
        </div>
      </ContentsCard>
      <ListGroup class="-note _mb-sm-30 _mb-md-60">
        <ListItem class="-note"
          >au PAY
          スマートローンのご契約・ご利用には審査がございます。審査状況によりご希望に添えない場合がございますので、あらかじめご了承ください。</ListItem
        >
      </ListGroup>

      <div class="container _mb-md-120 _mb-sm-60">
        <BtngroupSingle>
          <BtnMain class="-normal -lg" router-name="sv002"
            >au PAY スマートローンの特徴について</BtnMain
          >
        </BtngroupSingle>
      </div>
      <CvBox class="-cv _mb-md-120 _mb-sm-60" />
    </div>

    <hr class="_mb-120 _mb-sm-60" />

    <div class="container">
      <HeadingTwo>おすすめ記事</HeadingTwo>

      <CardGroups class="-image-top-list">
        <CardBox router-name="sv008" class="-image-top">
          <CardHeader>
            <CardImage class="-blue"
              ><img
                src="@/assets/images/sv/sv008/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">急な飲み会・・・給料日前だけど参加したい！</h3>
          </CardHeader>
          <CardBody
            >お誘いが多いのはうれしいけど、飲み会の回数が重なると結構な出費に…。
          </CardBody>
        </CardBox>

        <CardBox router-name="sv006" class="-image-top">
          <CardHeader>
            <CardImage class="-blue"
              ><img
                src="@/assets/images/sv/sv006/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">結婚＆出産…お祝いは突然やってくる？</h3>
          </CardHeader>
          <CardBody
            >「お祝い」続きで資金不足に…せっかくのお祝いを諦める？</CardBody
          >
        </CardBox>

        <CardBox router-name="sv007" class="-image-top">
          <CardHeader>
            <CardImage class="-blue"
              ><img
                src="@/assets/images/sv/sv007/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">せっかくの卒業旅行…お金のことで諦めないで！</h3>
          </CardHeader>
          <CardBody
            >楽しいはずの旅行…お金の都合で妥協したり、諦めかけたことってありませんか？</CardBody
          >
        </CardBox>
      </CardGroups>
    </div>
    <!-- container -->
  </div>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import HeadingTwo from "@/components/heading/HeadingTwo";
import BtnMain from "@/components/button/BtnMain";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import CardBody from "@/components/card/CardBody";
import CardGroups from "@/components/card/CardGroups";
import CardImage from "@/components/card/CardImage";
import IconBox from "@/components/icons/IconBox";
import ContentsHeader from "@/components/contents/ContentsHeader";
import ContentsIntro from "@/components/contents/ContentsIntro";
import ContentsCard from "@/components/contents/ContentsCard";
import TalkGroup from "@/components/contents/TalkGroup";
import TalkBox from "@/components/contents/TalkBox";
import CvBox from "@/components/box/CvBox";

export default {
  name: "Sv053",
  components: {
    BreadcrumbGroup,
    CardBody,
    CardImage,
    CardHeader,
    CardBox,
    CardGroups,
    CvBox,
    BtnMain,
    BtngroupSingle,
    ListItem,
    ListGroup,
    IconBox,
    ContentsCard,
    TalkBox,
    TalkGroup,
    HeadingTwo,
    ContentsIntro,
    ContentsHeader,
  },
  setup() {
    setMeta({
      title:
        "“ちょっとだけ”がすごく助かる生活の工夫｜教えて！みんなのローン活用術",
      description:
        "みんなのローンの活用術！日用品購入などで生活費ちょっと足りないときに。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,工夫",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "知っておきたい！ローンについて",
          routerName: "sv003",
        },
        {
          text: "教えて！みんなのローン活用術",
          routerName: "sv042",
        },
        {
          text: '"ちょっとだけ"がすごく助かる生活の工夫',
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.contents-card {
  > .card-body {
    padding-left: 20px;
    padding-right: 20px;
    @include mq-up(md) {
      padding-left: 50px !important;
      padding-right: 50px !important;
    }
    > .txt01 {
      text-align: center;
      margin-bottom: 0px;
    }
    > .card-groups {
      @include mq-up(md) {
        display: flex;
        justify-content: space-between;
      }
      > .card-box {
        @include mq-up(md) {
          width: 30%;
        }
        > .card-image {
          margin: 0 auto 20px;
          &.-width80 {
            max-width: 62%;
          }
          &.-width90 {
            max-width: 90%;
          }
        }
      }
    }
  }
}
</style>
